// extracted by css-extract-rspack-plugin
export default {"CustomPropertySelectPanelButton":"CustomPropertySelectPanel-module__CustomPropertySelectPanelButton__U4ZZE5A"};